export default {
  'actions.login': 'Войти',
  'actions.logout': 'Выйти',
  'actions.register': 'Регистрация',
  'actions.resetPassword': 'Сбросить пароль',
  'actions.sendVerificationEmail': 'Отправить письмо с подтверждением',
  'actions.verifyEmail': 'Подтвердить email',
  'actions.create': 'Создать',
  'actions.view': 'Просмотр',
  'actions.viewAll': 'Посмотреть все',
  'actions.viewDetails': 'Подробнее',
  'actions.assign': 'Назначить',
  'actions.unAssign': 'Снять назначение',
  'actions.assignAll': 'Назначить все',
  'actions.unAssignAll': 'Снять все назначения',
  'actions.unassigned': 'Не назначено',
  'actions.generate': 'Сгенерировать',
  'actions.manage': 'Управлять',
  'actions.change': 'Изменить',
  'actions.sendMessage': 'Отправить',
  'actions.sort': 'Сортировать',
  'actions.ok': 'OK',
  'actions.publish': 'Опубликовать',
  'actions.refresh': 'Обновить',
  'actions.draft': 'Черновик',
  'actions.hide': 'Скрыть {{type}}',
  'actions.unHide': 'Показать {{type}}',
  'actions.like': 'Нравится',
  'actions.unLike': 'Не нравится',
  'actions.more': 'Ещё',
  'actions.time': 'Время',
  'actions.share': 'Поделиться',
  'actions.shareOn': 'Поделиться в {{type}}',
  'actions.export': 'Экспорт',
  'actions.edit': 'Редактировать {{type}}',
  'actions.show': 'Показать {{type}}',
  'actions.showOnMap': 'Показать на карте',
  'actions.download': 'Скачать файл',
  'actions.exportAs': 'Экспортировать как {{type}}',
  'actions.email': 'Отправить email',
  'actions.copy': 'Копировать',
  'actions.copied': 'Скопировано',
  'actions.save': 'Сохранить',
  'actions.activate': 'Активировать',
  'actions.deactivate': 'Деактивировать',
  'actions.preview': 'Предпросмотр',
  'actions.hold': 'Приостановить',
  'actions.delete': 'Удалить',
  'actions.deleteEntity': 'Удалить {{type}}',
  'actions.update': 'Обновить',
  'actions.upload': 'Загрузить',
  'actions.reload': 'Перезагрузить',
  'actions.screenshot': 'Скриншот',
  'actions.views': 'Просмотры',
  'actions.close': 'Закрыть',
  'actions.confirm': 'Подтвердить',
  'actions.add': 'Добавить {{type}}',
  'actions.back': 'Назад',
  'actions.cancel': 'Отмена',
  'actions.select': 'Выбрать',
  'actions.unselect': 'Отменить выбор',
  'actions.setAs': 'Установить как {{type}}',
  'actions.search': 'Поиск',
  'actions.new': 'Новый',
  'actions.next': 'Далее',
  'actions.prev': 'Назад',
  'actions.yes': 'Да',
  'actions.no': 'Нет',
  'actions.leave': 'Покинуть',
  'actions.stay': 'Остаться',
  'actions.clone': 'Клонировать',
  'actions.cloneEntity': 'Клонировать {{type}}',
};
